export default __webpack_public_path__ + "static/media/qrcode-scan.a612943b.PNG";